import * as React from 'react';

const HeartFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="heart-fill_svg__eds-icon--heart-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="heart-fill_svg__eds-icon--heart-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 3C14 3 12 5.5 12 5.5S10 3 7.5 3C4.5 3 2 5 2 8c0 2 .5 3 2 4.5l8 8 8-8C21.5 11 22 10 22 8c0-3-2.5-5-5.5-5"
        />
    </svg>
);

HeartFillSvg.displayName = 'HeartFillSvg';
export default HeartFillSvg;
